/* Marina Soler — carrito: total en el botón + productos recomendados */
(function () {
  if (window.msrCartLoaded) return;
  window.msrCartLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastProductId = null;

  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getCart() {
    return fetch(root + 'cart.js?t=' + Date.now(), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function updateTotal(cart) {
    document.querySelectorAll('[data-msr-cart-total]').forEach(function (el) { el.innerHTML = money(cart.total_price); });
  }

  function renderUpsell(cart) {
    var box = document.querySelector('[data-msr-upsell]');
    if (!box) return;
    if (!cart.items.length) { box.hidden = true; lastProductId = null; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    if (pid === lastProductId && box.dataset.loaded) {
      // solo ocultar los que ya están en el carrito
      box.querySelectorAll('[data-product-id]').forEach(function (c) { c.hidden = inCart.indexOf(+c.dataset.productId) > -1; });
      return;
    }
    lastProductId = pid;
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data.products || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; });
        var track = box.querySelector('[data-msr-upsell-track]');
        if (!list.length) { box.hidden = true; return; }
        track.innerHTML = list.map(function (p) {
          var vars = p.variants.filter(function (v) { return v.available; });
          var v0 = vars[0];
          var opts = vars.length > 1 || p.variants.length > 1
            ? '<select data-msr-upsell-variant>' + vars.map(function (v) {
                return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '">' + esc(v.title) + '</option>';
              }).join('') + '</select>'
            : '<input type="hidden" data-msr-upsell-variant value="' + v0.id + '">';
          var cmp = v0.compare_at_price > v0.price ? '<s data-msr-up-compare>' + money(v0.compare_at_price) + '</s>' : '<s data-msr-up-compare hidden></s>';
          return '<div class="msr-upsell__card" data-product-id="' + p.id + '">' +
              '<a href="' + p.url + '" class="msr-upsell__img"><img src="' + img(p.featured_image, 160) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
              '<div class="msr-upsell__info">' +
                '<a href="' + p.url + '" class="msr-upsell__name">' + esc(p.title) + '</a>' +
                '<div class="msr-upsell__price">' + cmp + '<span data-msr-up-price>' + money(v0.price) + '</span></div>' +
                opts +
              '</div>' +
              '<button type="button" class="msr-upsell__add" data-msr-upsell-add>+ Añadir</button>' +
            '</div>';
        }).join('');
        box.dataset.loaded = '1';
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }

  /* ---------- Barra de descuentos por cantidad ---------- */
  function updateTiers(cart) {
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-msr-tiers]').forEach(function (box) {
      var tiers = box.getAttribute('data-msr-tiers').split(',').map(function (t) {
        var p = t.split(':'); return { q: +p[0], pc: p[1] };
      });
      var n = tiers.length, next = null, best = null, prevQ = 0, fill = 100;
      for (var i = 0; i < n; i++) {
        if (count >= tiers[i].q) { best = tiers[i]; prevQ = tiers[i].q; }
        else { next = tiers[i]; fill = (i + (count - prevQ) / (tiers[i].q - prevQ)) * 100 / n; break; }
      }
      var msg = box.querySelector('[data-msr-tiers-msg]');
      if (msg) {
        if (next) {
          var miss = next.q - count;
          msg.innerHTML = 'Añade <b>' + miss + '</b> ' + (miss === 1 ? 'artículo' : 'artículos') + ' más para un <b>' + next.pc + '%</b> de descuento';
        } else {
          msg.innerHTML = '¡Enhorabuena! Tienes un <b>' + best.pc + '%</b> de descuento';
        }
      }
      var bar = box.querySelector('[data-msr-tiers-fill]');
      if (bar) bar.style.width = fill.toFixed(1) + '%';
      box.querySelectorAll('[data-msr-tier-qty]').forEach(function (st) {
        st.classList.toggle('is-done', count >= +st.getAttribute('data-msr-tier-qty'));
      });
    });
  }

  /* ---------- Temporizador "artículos reservados" ----------
     - Carrito vacío: el reloj se queda parado en el inicio (p. ej. 10:00).
     - Se pone en marcha cuando se añade el primer producto.
     - Si se quita un producto (o se vacía el carrito), vuelve al inicio.
     - Al llegar a 00:00 con productos, vuelve a empezar. */
  var TIMER_KEY = 'msrCartTimerEnd';
  var cartCount = null; // desconocido hasta leer el carrito
  function timerMinutes() {
    var el = document.querySelector('[data-msr-timer]');
    return (el && +el.getAttribute('data-msr-timer-minutes')) || 10;
  }
  function getEnd() { try { return +sessionStorage.getItem(TIMER_KEY) || 0; } catch (e) { return 0; } }
  function setEnd(v) { try { v ? sessionStorage.setItem(TIMER_KEY, String(v)) : sessionStorage.removeItem(TIMER_KEY); } catch (e) {} }
  function fmt(sec) { return String(Math.floor(sec / 60)).padStart(2, '0') + ':' + String(sec % 60).padStart(2, '0'); }
  var COUNT_KEY = 'msrCartCount';
  function getLastCount() { try { var v = sessionStorage.getItem(COUNT_KEY); return v === null ? null : +v; } catch (e) { return null; } }
  function setLastCount(v) { try { sessionStorage.setItem(COUNT_KEY, String(v)); } catch (e) {} }
  function syncTimer(count) {
    var last = getLastCount();
    cartCount = count;
    if (!count) {
      setEnd(0);                                   // carrito vacío: reloj parado en el inicio
    } else if (!getEnd() || (last !== null && count < last)) {
      setEnd(Date.now() + timerMinutes() * 60000); // primer producto o se ha quitado algo: vuelve a empezar
    }
    setLastCount(count);
    tickTimer();
  }
  function tickTimer() {
    if (!document.querySelector('[data-msr-timer]')) return;
    var total = timerMinutes() * 60, left = total;
    if (cartCount) {
      var end = getEnd(), now = Date.now();
      if (!end || end <= now) { end = now + total * 1000; setEnd(end); }
      left = Math.max(0, Math.round((end - now) / 1000));
    }
    var txt = fmt(left);
    document.querySelectorAll('[data-msr-timer-clock]').forEach(function (c) { c.textContent = txt; });
  }
  tickTimer();
  setInterval(tickTimer, 1000);

  /* Detecta cualquier cambio del carrito (añadir, cambiar cantidad, eliminar) */
  if (window.fetch && !window.msrFetchWrapped) {
    window.msrFetchWrapped = true;
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
      }
      return p;
    };
  }

  function refresh() { getCart().then(function (cart) { syncTimer(cart.item_count || 0); updateTotal(cart); updateTiers(cart); renderUpsell(cart); }); }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-msr-upsell-variant]');
    if (!sel) return;
    var o = sel.options[sel.selectedIndex];
    var card = sel.closest('.msr-upsell__card');
    var price = +o.dataset.price, cmp = +o.dataset.compare;
    card.querySelector('[data-msr-up-price]').innerHTML = money(price);
    var c = card.querySelector('[data-msr-up-compare]');
    c.hidden = !(cmp > price);
    if (cmp > price) c.innerHTML = money(cmp);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.msr-remove');
    if (rm) {
      e.preventDefault();
      var key = rm.closest('[data-key]').getAttribute('data-key');
      rm.closest('.cart__item').style.opacity = '.4';
      fetch(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        refresh();
      });
      return;
    }
    var btn = e.target.closest('[data-msr-upsell-add]');
    if (btn) {
      var card = btn.closest('.msr-upsell__card');
      var id = card.querySelector('[data-msr-upsell-variant]').value;
      btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.disabled = false;
        if (res.status) { alert(res.description || res.message); return; }
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(refresh, 400);
      }).catch(function () { btn.disabled = false; });
      return;
    }
    var nav = e.target.closest('[data-msr-upsell-prev],[data-msr-upsell-next]');
    if (nav) {
      var track = document.querySelector('[data-msr-upsell-track]');
      var dir = nav.hasAttribute('data-msr-upsell-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });

  ['cart:updated', 'ajaxProduct:added', 'drawerOpen', 'cart:build'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 500); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
